import React from "react";
import "./MenuDrawer.css";
import { menu } from "../../data";

const MenuDrawer = () => {
  const close = () => {
    let drawer = document.getElementsByClassName("menu-drawer")[0];
    drawer.classList.add("menu-drawer--close");

    drawer.classList.remove("menu-drawer--open--mobile");
    drawer.classList.remove("menu-drawer--open--desktop");
  };

  return (
    <div className="menu-drawer">
      <div className="menu-drawer--box-1">
        <button type="button" className="closeMenu" onClick={close}>
          &times;
        </button>
      </div>
      <ul className="menu-drawer__links">
        {menu.slice(0, 3).map((x) => (
          <li key={x}>
            <a
              href={`#${x}`}
              className="body-1 menu-drawer__link"
              onClick={() => close()}
            >
              {x}
            </a>
          </li>
        ))}
        <li>
          <a
            href={`https://d-resume-copy.netlify.app/`}
            className="body-1 menu-drawer__link"
            target="_blank"
            rel="noreferrer"
          >
            {menu[3]}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default MenuDrawer;
